import merge from 'lodash/merge';
import pick from 'lodash/pick';

const baseModel = {
  id: undefined,
  testingEvent: {
    id: undefined,
    adminId: {
      id: undefined,
    },
    testDate: '',
  },
  optOutFlag: false,
  equatingFlag: false,
  unlistedFlag: false,
  paperRosterReceivedFlag: false,
  internalReviewStatus: 'pending',
  testCenterCycleId: undefined,
  testCenterEventStatus: 'OPEN',
  message: '',
  locationEvents: [],
  forceClosedFlag: false,
  unlimitedRoomProctorsFlag: false,
  unlimitedRovingProctorsFlag: false,
  paperStorageFlag: false,
 /* changes for scratchPaper attestation*/
  scratchPaperFlag: false,
  eventCheckoutFlag: false,
};

const locationEventBase = {
  id: undefined,
  testCenterEventId: undefined,
  locationId: undefined,
  status: 'OPEN',
  locationEventCapacities: [],
  capacityStandard: undefined,
  capacityExtended: undefined,
  capacityOnline: undefined,
  capacitySingleRoom: undefined,
};

const locationEventExamBase = {
  id: undefined,
  locationEventId: undefined,
  capacityTypeId: undefined,
  capacity: 0,
  registrationAssignCount: 0,
};

export class TestEvent {
  constructor(data) {
    merge(this, baseModel, pick(data, Object.keys(baseModel)));
  }
}

export class LocationEvent {
  constructor(data) {
    merge(this, locationEventBase, pick(data, Object.keys(locationEventBase)));
  }
}

export class LocationEventExam {
  constructor(data) {
    merge(
      this,
      locationEventExamBase,
      pick(data, Object.keys(locationEventExamBase))
    );
  }
}
